import { Button } from '@cargoflow/ui/components/button'
import { createFileRoute, redirect, useNavigate, useRouter } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { getSession } from '@/lib/auth-client'

function AuthenticatedErrorComponent() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { history } = useRouter()

  return (
    <div className="flex h-[50vh] w-full flex-col items-center justify-center gap-2">
      <span className="font-medium">
        {t('errors.something_went_wrong', { defaultValue: 'Something went wrong' })}
      </span>
      <p className="text-center text-muted-foreground">
        {t('errors.try_again', { defaultValue: 'Please try again or go back.' })}
      </p>
      <div className="mt-4 flex gap-4">
        <Button variant="outline" onClick={() => history.go(-1)}>
          {t('common.go_back', { defaultValue: 'Go Back' })}
        </Button>
        <Button onClick={() => navigate({ to: '/' })}>
          {t('common.back_to_home', { defaultValue: 'Back to Home' })}
        </Button>
      </div>
    </div>
  )
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location }) => {
    const session = await getSession()

    if (!session.data) {
      throw redirect({
        to: '/sign-in',
        search: {
          redirect: location.pathname,
        },
      })
    }

    return {
      user: session.data.user,
      session: session.data.session,
    }
  },
  component: AuthenticatedLayout,
  errorComponent: AuthenticatedErrorComponent,
})
